module.exports = __webpack_public_path__ + "img/lbr.fc1fed7c.webp";